module.exports = __webpack_public_path__ + "static/img/6.dde8f3e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/2/sp/6.png
// module id = VC7H
// module chunks = 0